const deployment: "production" | "development" | void = process.env.REACT_APP_ENV as any;
let fbConfig = {};
let projectLocation = "";

const gaCode = deployment === "production" ? "UA-192108315-1" : "G-P9WMCDQ561";

setTimeout(() => {
  const scriptTag = document.createElement("script");
  scriptTag.setAttribute("async", "async");
  scriptTag.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${gaCode}`);
  document.body.appendChild(scriptTag);
}, 0);

// Setup the proper values based on if we're using a dev or prod backend
// @ts-ignore
if (deployment === "production") {
  fbConfig = {
    apiKey: "AIzaSyAn6pWd7Q_SUDf4mgB3SqcVZ19AbfnbB9k",
    authDomain: "readtome-272220.firebaseapp.com",
    databaseURL: "https://readtome-272220.firebaseio.com",
    projectId: "readtome-272220",
    storageBucket: "readtome-272220.appspot.com",
    messagingSenderId: "173318682883",
    appId: "1:173318682883:web:298a4bd08d0aeebc915136",
    measurementId: "G-WHZ4T6SLZG",
  };

  projectLocation = "gs://readtome-272220";
} else {
  fbConfig = {
    apiKey: "AIzaSyDPZt2IcZy2hGW46rtVZ7bHWH43S-lgKc4",
    authDomain: "readtomedev-81db7.firebaseapp.com",
    databaseURL: "https://readtomedev-81db7.firebaseio.com",
    projectId: "readtomedev-81db7",
    storageBucket: "readtomedev-81db7.appspot.com",
    messagingSenderId: "756069640519",
    appId: "1:756069640519:web:c3a0e8c32a6e9b3c2a0462",
    measurementId: "G-X3VYFX1XMB",
  };

  projectLocation = "gs://readtomedev-81db7";
}

const w = window as any;
w.dataLayer = w.dataLayer || [];
function gtag(...args: any[]) {
  w.dataLayer.push(args);
}
gtag("js", new Date());

gtag("config", gaCode);

export { fbConfig, deployment, projectLocation };
